import {
    IDataArray,
} from "./../../shared/index"

export class SurveyResults implements IDataArray {
    public Pkid = 0;
    public UserId: number;
    public SurveyId: number;
    public Submitted: Date;
    public Image: Blob;
    public AnnotationDoc: Blob;
    public Note: string;
    public SurveyDetails: string;

    public GetById(): number {
        return this.Pkid;
    }
}